/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SiteNav_viewer$ref = any;
export type SiteNavRefetchQueryVariables = {
    readonly fetchNav: boolean;
    readonly fetchTradeNav: boolean;
    readonly fetchSubNav: boolean;
    readonly previewKey?: string | null;
};
export type SiteNavRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": SiteNav_viewer$ref;
    } | null;
};
export type SiteNavRefetchQuery = {
    readonly response: SiteNavRefetchQueryResponse;
    readonly variables: SiteNavRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "fetchNav",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchTradeNav",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchSubNav",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "previewKey",
            "type": "String",
            "defaultValue": ""
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "Variable",
        "name": "rootId",
        "variableName": "previewKey"
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isLinkable",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "modules",
            "storageKey": null,
            "args": null,
            "concreteType": "NavigationModule",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "imageUrl",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "imageLink",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "imageTitlePrimary",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "imageTitleSecondary",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "imageHeight",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "imageWidth",
                    "args": null,
                    "storageKey": null
                },
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isHighlighted",
                    "args": null,
                    "storageKey": null
                },
                (v6 /*: any*/),
                (v1 /*: any*/),
                {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchSubNav",
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "NavigationTopLevel",
                            "plural": true,
                            "selections": [
                                (v6 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "column",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "items",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "NavigationItem",
                                    "plural": true,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v1 /*: any*/)
                                    ]
                                },
                                (v1 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        } as any),
        (v1 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SiteNavRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SiteNav_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SiteNavRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchNav",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "navigation",
                                    "name": "navigation",
                                    "storageKey": null,
                                    "args": [
                                        (v2 /*: any*/)
                                    ],
                                    "concreteType": "Navigation",
                                    "plural": false,
                                    "selections": (v7 /*: any*/)
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchTradeNav",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "tradeNavigation",
                                    "name": "navigation",
                                    "storageKey": null,
                                    "args": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "userType",
                                            "value": "TRADE"
                                        }
                                    ],
                                    "concreteType": "Navigation",
                                    "plural": false,
                                    "selections": (v7 /*: any*/)
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SiteNavRefetchQuery",
            "id": "ferrum/234.0.0-2019-09-20T21:19:24.316Z/SiteNavRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '0875f0256ad7bc1982a275a19c88c34a';
export default node;
